import { REDUX_DOMAIN_LIST_SECTION_KEY } from '../../redux/constants/key'
import { PROFILE_LOGS_DOMAIN } from './domain'
import { PROFILE_LOGS_KEY } from './key'

const PROFILE_LOGS_PATH = {
  ALL: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.ALL}`,
  ALL_DATA: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.ALL}.data`,
  BY_PROFILE_ID: `${PROFILE_LOGS_DOMAIN}.${REDUX_DOMAIN_LIST_SECTION_KEY.BY_PROFILE_ID}`,
  CURRENT: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.CURRENT}`,
  DATA: `${PROFILE_LOGS_DOMAIN}.${PROFILE_LOGS_KEY.DATA}`
}

export { PROFILE_LOGS_PATH }
